import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Paper, TextField, Button, Typography, Alert, CircularProgress } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import apiService from '../services/api';

const FirstLogin: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setError('');
    setLoading(true);
    try {
      await apiService.firstLogin(email, password);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
          <Typography component="h1" variant="h5" align="center" fontWeight={700} gutterBottom>
            First Time Login
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 3 }}>
            Enter your work email and choose a password to activate your account.
          </Typography>

          {success ? (
            <Alert severity="success">Password set! Redirecting to login…</Alert>
          ) : (
            <Box component="form" onSubmit={handleSubmit}>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              <TextField
                margin="normal" required fullWidth
                label="Work Email" type="email"
                value={email} onChange={e => setEmail(e.target.value)}
                disabled={loading} autoFocus
              />
              <TextField
                margin="normal" required fullWidth
                label="New Password" type="password"
                value={password} onChange={e => setPassword(e.target.value)}
                disabled={loading}
              />
              <TextField
                margin="normal" required fullWidth
                label="Confirm Password" type="password"
                value={confirm} onChange={e => setConfirm(e.target.value)}
                disabled={loading}
              />
              <Button
                type="submit" fullWidth variant="contained"
                sx={{ mt: 2, mb: 2 }} disabled={loading || !email || !password || !confirm}
              >
                {loading ? <CircularProgress size={24} color="inherit" /> : 'Set Password & Login'}
              </Button>
              <Box textAlign="center">
                <Typography component={RouterLink} to="/login" variant="body2"
                  sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
                  Already have a password? Sign in
                </Typography>
              </Box>
            </Box>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default FirstLogin;
